import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setIsLowDPIWarningEnabledReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isLowDPIWarningEnabled = action.payload;
};

export default setIsLowDPIWarningEnabledReducer;
